"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionToJSON = exports.PromotionFromJSONTyped = exports.PromotionFromJSON = exports.instanceOfPromotion = void 0;
var runtime_1 = require("../runtime");
var ConversionEvent_1 = require("./ConversionEvent");
var PromotionGoal_1 = require("./PromotionGoal");
/**
 * Check if a given object implements the Promotion interface.
 */
function instanceOfPromotion(value) {
    var isInstance = true;
    isInstance = isInstance && "promotionGoal" in value;
    return isInstance;
}
exports.instanceOfPromotion = instanceOfPromotion;
function PromotionFromJSON(json) {
    return PromotionFromJSONTyped(json, false);
}
exports.PromotionFromJSON = PromotionFromJSON;
function PromotionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promotionGoal': (0, PromotionGoal_1.PromotionGoalFromJSON)(json['promotion_goal']),
        'promotionTargetId': !(0, runtime_1.exists)(json, 'promotion_target_id') ? undefined : json['promotion_target_id'],
        'conversionEvents': !(0, runtime_1.exists)(json, 'conversion_events') ? undefined : (new Set(json['conversion_events'].map(ConversionEvent_1.ConversionEventFromJSON))),
    };
}
exports.PromotionFromJSONTyped = PromotionFromJSONTyped;
function PromotionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promotion_goal': (0, PromotionGoal_1.PromotionGoalToJSON)(value.promotionGoal),
        'promotion_target_id': value.promotionTargetId,
        'conversion_events': value.conversionEvents === undefined ? undefined : (Array.from(value.conversionEvents).map(ConversionEvent_1.ConversionEventToJSON)),
    };
}
exports.PromotionToJSON = PromotionToJSON;
